module.exports = __webpack_public_path__ + "img/regiter-icon07.dbbdb8db.png";